import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ContractService } from "../../../../auth/service/contract.service";
import { CitiesService } from "../../../../auth/service/cities.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient, HttpRequest } from "@angular/common/http";
import * as moment from "moment/moment";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { CandidateService } from "../../../recruitment/candidates/candidate.service";
import { CollaboratorsService } from "../../collaborators.service";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IProvider } from "app/modules/providers/models/providers";
import { ProvidersService } from "app/modules/providers/providers.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

//Interfaccia Collaborator
export interface Collaborator {
  firstname: string;
  lastname: string;
  phone: string;
  private_email: string;
  provider_id: number;
  type: string;
  fiscalcode: string;
  email: string;
  business_name: string;
  figure_id: number;
  vat_number: string;
  unique_code: string;
  pec: string;
  sex: string;
  birthday: string;
  badge_number: string;
  hash?: string;
  note: string;
  addresses: any;
  contract: {
    start_date: string;
    end_date: string;
    tutor_hash: string;
    total_daily: string;
  };
  request_id?: null | number;
}

@Component({
  selector: "app-form-add-collaborator",
  templateUrl: "./form-add-collaborator.component.html",
  styleUrls: ["./form-add-collaborator.component.scss"],
})
export class FormAddCollaboratorComponent implements OnInit {
  public formGroup: FormGroup;
  public contentHeader: IContentHeader = {
    headerTitle: 'ADD_COLLABORATOR',
    actionButton: false,
    breadcrumb: {
      type: "",
      links: [
        {
          name: "Home",
          isLink: true,
          link: "/",
        },
        {
          name: 'MENU.USERS',
          isLink: false,
        },
        {
          name: 'TITLES.USERS_TYPES.collaborator',
          isLink: true,
          link: "/dashboard/collaborators/list",
        },
        {
          name: 'ADD_COLLABORATOR',
          isLink: false,
        },
      ],
    },
  };
  public activeTab: string = "masterdata";
  public new_skill: string;
  public fileName: string = null;
  public typeCollaborator: Array<string> = ["Stagista", "Partita iva", "Prestazione occasionale", "Da fornitore"];
  public userList: any = [];
  public uploadErrors: any[] = [];
  public isUploaded: number = 0;
  public files_list: any[] = [];
  public files_list_obj: any[] = [];
  public user_hash: string = null;
  public selectedCandidate: any = null;
  public min_birthdate: any = moment().subtract(18, "year").format("YYYY-MM-DD");
  public today: any = moment().format("YYYY-MM-DD");
  public showErrors: boolean = false;
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;
  public isCopingResidence: boolean = false;
  public providers: IProvider[] = [];

  referral_request_id: number | null = null;
  referral_request_name: string | null = null;

  constructor(
    public _authenticationService: AuthenticationService,
    private _userService: UserService,
    public _utilService: UtilsService,
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    public _contractService: ContractService,
    public _citiesService: CitiesService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    public _modalService: NgbModal,
    public _httpClient: HttpClient,
    public _userFigureService: UserFigureService,
    public _candidateService: CandidateService,
    public _collaboratorsService: CollaboratorsService,
    public _providersService: ProvidersService,
  ) {
    this._utilService.disableAutoHideLoading();
    //Se presenta un hash stiamo trasformando un candidato a collaboratore
    this._activatedRoute.queryParams.subscribe((params) => {
      this.user_hash = params.hash;
      this.referral_request_id = params.request || null;
      this.referral_request_name = params.request_name || null;
    });

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      phone: new FormControl(null, [Validators.required, Validators.minLength(9), Validators.maxLength(255), Validators.pattern("[0-9, +]+")]),
      private_email: new FormControl(null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"), Validators.email]),
      type: new FormControl("Stagista", [Validators.required]),
      fiscalcode: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"), Validators.email]),
      figure_id: new FormControl(null, [Validators.required]),
      business_name: new FormControl(null),
      sex: new FormControl("m"),
      badge_number: new FormControl(null, [Validators.maxLength(5), Validators.minLength(1)]),
      birthday: new FormControl(null),
      start_date: new FormControl(null, [Validators.required]),
      end_date: new FormControl(null, [Validators.required]),
      vat_number: new FormControl(null),
      unique_code: new FormControl(null),
      provider_id: new FormControl(null),
      pec: new FormControl(null, [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"), Validators.email]),
      street: new FormControl(null),
      zipcode: new FormControl(null, [Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      city_id: new FormControl(null),
      province_id: new FormControl(null),
      country: new FormControl(null),
      external: new FormControl(false),
      billing_street: new FormControl(null),
      billing_zipcode: new FormControl(null),
      billing_city: new FormControl(null),
      billing_province: new FormControl(null),
      billing_country: new FormControl(null),
      billing_external: new FormControl(false),
      tutor_hash: new FormControl(null, [Validators.required]),
      total_daily: new FormControl(0, [Validators.required]),
      note: new FormControl(null),
      send_welcome_email: new FormControl(null),
      request_id: new FormControl(null)
    });
  }

  async ngOnInit() {
    this._utilService.showLoading()
    await this.loadUserData();
    this.changeTypeUser("Stagista");
  }

  async loadUserData() {
    if (this.user_hash && this.user_hash.length > 0) {
      this.selectedCandidate = await this._candidateService.getCandidate(this.user_hash).catch(async () => {
        await this._utilService.showSWALError({ text: "NOT_FOUND_CANDIDATE" });
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      });
      this.formGroup.patchValue({
        firstname: this.selectedCandidate.firstname,
        lastname: this.selectedCandidate.lastname,
        phone: this.selectedCandidate.phone,
        private_email: this.selectedCandidate.email,
        fiscalcode: this.selectedCandidate.fiscalcode,
        figure_id: this.selectedCandidate.figure_id,
        birthday: !!this.selectedCandidate.birthday ? moment(this.selectedCandidate.birthday).format("YYYY-MM-DD") : null,
        sex: this.selectedCandidate.sex,
      });

      this.contentHeader.headerTitle = `${this.selectedCandidate.firstname} ${this.selectedCandidate.lastname}`
      this.contentHeader.breadcrumb.links[3].name = 'TRANSFORM_TO_COLLABORATOR'
    }

    if(this.referral_request_id){
      this.formGroup.patchValue({ request_id: Number(this.referral_request_id) })
    }

    this.userList = await this._userService.getList("employee");
    this.providers = await this._providersService.getList();
    this._utilService.hideLoading();
  }

  setAutoProvince(address_label: string = "Residence") {
    if (address_label === "Residence") {
      const cityValue: number = this.formGroup.get("city_id").value;
      if (cityValue > 0) {
        const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityValue);
        const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
        this.formGroup.patchValue({ province_id: province.id });
      }
    } else {
      const cityValue: number = this.formGroup.get("billing_city").value;
      if (cityValue > 0) {
        const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityValue);
        const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
        this.formGroup.patchValue({ billing_province: province.id });
      }
    }
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  changeTypeUser(value: string) {
    /*Resettiamo alcuni campi*/
    this.formGroup.patchValue({
      vat_number: null,
      pec: null,
      business_name: null,
      unique_code: null,
      billing_street: null,
      billing_zipcode: null,
      billing_city: null,
      billing_province: null,
      badge_number: null,
      provider_id: null,
      tutor_hash: null,
      send_welcome_email: null,
    });
    //Nel caso siano stati resettati da fornitore
    this.formGroup.controls.provider_id.clearValidators();
    this.formGroup.controls.phone.setValidators([Validators.required]);
    this.formGroup.controls.phone.setValidators([Validators.minLength(9)]);
    this.formGroup.controls.phone.setValidators([Validators.maxLength(255)]);
    this.formGroup.controls.phone.setValidators([Validators.pattern("[0-9, +]+")]);

    if (value === "Stagista" || value === "Prestazione occasionale") {
      //Clear Validators
      this.formGroup.controls.vat_number.clearValidators();
      //Set Validators
      this.formGroup.controls.fiscalcode.setValidators([Validators.required, Validators.minLength(16), Validators.maxLength(16)]);
      this.formGroup.controls.tutor_hash.setValidators([Validators.required]);
    } else {
      if (value === "Partita iva") {
        //Clear Validators
        this.formGroup.controls.fiscalcode.clearValidators();
        this.formGroup.controls.tutor_hash.clearValidators();
        //Set Validators
        this.formGroup.controls.vat_number.setValidators([Validators.required, Validators.minLength(11), Validators.maxLength(11)]);
      }
      if (value === "Da fornitore") {
        this.formGroup.controls.vat_number.clearValidators();
        this.formGroup.controls.fiscalcode.clearValidators();
        this.formGroup.controls.tutor_hash.clearValidators();
        this.formGroup.controls.provider_id.setValidators([Validators.required]);
      }
    }
    //update
    this.formGroup.controls.vat_number.updateValueAndValidity();
    this.formGroup.controls.tutor_hash.updateValueAndValidity();
    this.formGroup.controls.fiscalcode.updateValueAndValidity();
    this.formGroup.controls.provider_id.updateValueAndValidity();
    this.formGroup.controls.phone.updateValueAndValidity();
  }

  formatCurrentRal() {
    this.formGroup.patchValue({
      total_daily: this._utilService.addDotsToNumber(this.formGroup.value.total_daily),
    });
  }

  async addFileToList(files: any) {
    // creo una variabile dalla lista attuale
    let updatedList: any[] = this.files_list_obj.filter((item: any) => item.name !== "");
    // ciclo tutti i files inviati
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      // aggiungo i files
      this.files_list.push(file);

      // aggiungo alla lista
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    // aggiorno variabile della pagina
    this.files_list_obj = updatedList;
  }

  uploadFiles(hash: string) {
    this.isUploaded = 1;
    this.files_list.map((file: File, index: number) => {
      const formData: FormData = new FormData();
      formData.append("file", file);

      const req: any = new HttpRequest("PUT", `/collaborator/contract-attachment/${hash}`, formData);

      this.files_list_obj[index].status = 1;

      return this._httpClient
        .request(req)
        .toPromise()
        .then(() => {
          this.files_list_obj[index].status = 2;
        })
        .catch((err: any) => {
          this.files_list_obj[index].status = 3;
          this.uploadErrors.push({
            filename: this.files_list_obj[index].name,
            error: err.toUpperCase().replace(/\s/gi, "_"),
          });
        });
    });
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async copyResidence() {
    //Resetto i valori
    this.formGroup.patchValue({
      billing_street: null,
      billing_zipcode: null,
      billing_city: null,
      billing_province: null,
      billing_country: null,
    });

    this.formGroup.patchValue({
      billing_street: this.formGroup.value.street,
      billing_zipcode: this.formGroup.value.zipcode,
      billing_city: this.formGroup.value.city_id,
      billing_province: this.formGroup.value.province_id,
      billing_country: this.formGroup.value.country,
      billing_external: this.formGroup.value.external,
    });

    this.manageExternalSiteBilling();
  }

  manageExternalSiteBilling() {
    this.isCopingResidence = false;
    if (this.formGroup.value.billing_external) {
      this.formGroup.patchValue({
        billing_province: null,
        billing_city: null,
        billing_zipcode: null,
      });
    } else {
      this.formGroup.patchValue({
        billing_country: null,
      });
    }
  }

  manageExternalSiteResidence() {
    this.isCopingResidence = false;
    if (this.formGroup.value.external) {
      this.formGroup.patchValue({
        province_id: null,
        city_id: null,
        zipcode: null,
      });
    } else {
      this.formGroup.patchValue({
        country: null,
      });
    }
  }

  async save() {
    if (!this._authenticationService.hasCapability("create_collaborator")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = true;

    if (this.formGroup.value.total_daily == 0 || this.formGroup.value.total_daily === "" || this.formGroup.value.total_daily === "0,00" || !this.formGroup.value.total_daily) {
      await this._utilService.showSWALError({ text: "ERROR_DAILY_COST_PRESUMED_EMPTY" });
      return false;
    }
    //Controllo alert campi mancanti
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    if (this.formGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      this.activeTab = "masterdata";

      return this._utilService.showSWALEmptyField({ text: textMessage });
    }

    //Indirizzi sono facoltativi ma controlliamo se almeno un campo è inserito tutti gli altri devono essere completi
    if (!this.formGroup.value.external) {
      if (!!this.formGroup.value.street || !!this.formGroup.value.city_id || !!this.formGroup.value.zipcode || !!this.formGroup.value.province_id) {
        if (!this.formGroup.value.street || !this.formGroup.value.city_id || !this.formGroup.value.zipcode || !this.formGroup.value.province_id) {
          await this._utilService.showSWALError({ text: "ERROR_RESIDENCE_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    } else {
      if (!!this.formGroup.value.street || !!this.formGroup.value.country) {
        if (!this.formGroup.value.street || !this.formGroup.value.country) {
          await this._utilService.showSWALError({ text: "ERROR_RESIDENCE_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    }
    if (!this.formGroup.value.billing_external) {
      if (!!this.formGroup.value.billing_street || !!this.formGroup.value.billing_city || !!this.formGroup.value.billing_zipcode || !!this.formGroup.value.billing_province) {
        if (!this.formGroup.value.billing_street || !this.formGroup.value.billing_city || !this.formGroup.value.billing_zipcode || !this.formGroup.value.billing_province) {
          await this._utilService.showSWALError({ text: "ERROR_BILLING_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    } else {
      if (!!this.formGroup.value.billing_street || !!this.formGroup.value.billing_country) {
        if (!this.formGroup.value.billing_street || !this.formGroup.value.billing_country) {
          await this._utilService.showSWALError({ text: "ERROR_BILLING_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    }

    let data: Collaborator = {
      firstname: this.formGroup.value.firstname,
      lastname: this.formGroup.value.lastname,
      phone: this.formGroup.value.phone,
      private_email: this.formGroup.value.private_email,
      type: this.formGroup.value.type === "Stagista" ? "stage" : this.formGroup.value.type === "Partita iva" ? "collaborator" : this.formGroup.value.type === "Da fornitore" ? "by-provider" : "occasional",
      fiscalcode: this.formGroup.value.fiscalcode,
      email: this.formGroup.value.email,
      provider_id: this.formGroup.value.provider_id,
      figure_id: this.formGroup.value.figure_id,
      sex: this.formGroup.value.sex,
      badge_number: this.formGroup.value.badge_number,
      birthday: this.formGroup.value.birthday,
      hash: this.user_hash,
      business_name: this.formGroup.value.business_name,
      vat_number: this.formGroup.value.vat_number,
      unique_code: this.formGroup.value.unique_code,
      pec: this.formGroup.value.pec,
      note: this.formGroup.value.note,
      request_id: this.formGroup.value.request_id,
      addresses: {},
      contract: {
        total_daily: this.formGroup.value.total_daily,
        start_date: this.formGroup.value.start_date,
        end_date: this.formGroup.value.end_date,
        tutor_hash: this.formGroup.value.tutor_hash,
      },
    };
    if (this.formGroup.value.street && this.formGroup.value.street.length > 0) {
      data.addresses.residenza = {
        street: this.formGroup.value.street,
        city_id: this.formGroup.value.city_id,
        zipcode: this.formGroup.value.zipcode,
        province_id: this.formGroup.value.province_id,
        country: this.formGroup.value.country,
      };
    }
    if (this.formGroup.value.billing_street && this.formGroup.value.billing_street.length > 0) {
      data.addresses.fatturazione = {
        street: this.formGroup.value.billing_street,
        city_id: this.formGroup.value.billing_city,
        zipcode: this.formGroup.value.billing_zipcode,
        province_id: this.formGroup.value.billing_province,
        country: this.formGroup.value.billing_country,
      };
    }

    this._utilService.showLoading();
    await this._collaboratorsService
      .createCollaborator(data)
      .then(async (response: any) => {
        this._utilService.hideLoading();
        this.uploadFiles(response.hash);
        if (this.formGroup.value.send_welcome_email) {
          await this._collaboratorsService.enableLogin(response.hash);
        }
        await this._utilService.showSWALSuccess({ text: this.selectedCandidate ? "SUCCESS_TRANSFORM_CANDIDATE_TO_COLLABORATOR" : "SUCCESS_CREATE_COLLABORATOR" });
        await this._router.navigateByUrl("/dashboard/collaborators/list");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: this.selectedCandidate ? "ERROR_TRANSFORM_CANDIDATE_TO_COLLABORATOR" : "ERROR_CREATE_COLLABORATOR" });
      });
  }
}
